/** Browser entry. Wiring only; nothing here is unit-tested. Configuration comes from VITE_* at build time. */
import { createRoot } from 'react-dom/client';
import { browserHttp, WebApi } from './api.js';
import { App } from './app.js';
import { fakeAuth, firebaseAuth, type AuthSession } from './auth.js';
import './ui/tokens.css';
import './ui/components.css';
import './app.css';

const env = import.meta.env;
let auth: AuthSession;
if (env.DEV && env.VITE_DEV_FAKE_AUTH === '1') {
  // Pairs with the API's DEV_FAKE_AUTH=1: signed in at once as the seeded dev admin, no Firebase project needed.
  const fake = fakeAuth();
  auth = fake;
  setTimeout(() => fake.signIn({ uid: 'dev_admin', email: 'dev_admin@example.test', name: 'Dev Admin' }, btoa(JSON.stringify({ uid: 'dev_admin', claims: { orgId: 'dev-org', role: 'admin', plan: 'studio', periodEnd: Date.now() + 30 * 86_400_000, claimsVersion: 1 }, email: 'dev_admin@example.test', emailVerified: true })).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '')), 0);
} else {
  auth = firebaseAuth({ apiKey: env.VITE_FIREBASE_API_KEY ?? '', authDomain: env.VITE_FIREBASE_AUTH_DOMAIN ?? '', projectId: env.VITE_FIREBASE_PROJECT_ID ?? '' }, window.location.origin);
}
const api = new WebApi(browserHttp, () => auth.idToken());
createRoot(document.getElementById('root')!).render(<App api={api} auth={auth} appUrl={window.location.origin} pricingUrl={env.VITE_PRICING_URL ?? '/pricing'} />);
